<template>
  <div class="main_topnav">
    <!-- 绑定一个全屏点击背景 并加入淡入淡出效果 -->
    <div
      :class="[
        this.regionMenuState.click
          ? 'click_background_active'
          : 'click_background',
        this.regionMenuState.fade ? 'fade_in_public' : 'fade_out_public'
      ]"
      @click="backgroundClickHandle"
    ></div>
    <!-- 常用页面的title -->
    <top-nav
      v-show="
        judgeActivePage() === '常用' ||
          judgeActivePage() === '修改常用场景' ||
          judgeActivePage() === '修改常用设备'
      "
    >
      <!-- 判断是不是界面管理状态 -->
      <!-- <top-nav-item
        v-if="$store.state.configinfo.objectMoveState"
        class="left_item "
      >
        <div slot="topimgtext">取消返回</div>
      </top-nav-item> -->
      <!-- 左 -->
      <top-nav-item class="left_item"></top-nav-item>
      <!-- 中 -->
      <top-nav-item>
        <!-- <div slot="topimgtext">这是您的家</div> -->
        <input
          type="text"
          slot="config_nickName_input"
          placeholder="请输入昵称"
          v-model="nickName"
          id="xiugaiName"
          @focus="xiugaiNameFocusHandle()"
          @blur="xiugaiNameBlurHandle()"
          @click="changeNickNameBtnHandle()"
        />
        <img
          v-if="nickNameChangeState === 0"
          slot="config_nickName_xiugai"
          src="../../../assets/img/config/xiugai.png"
          alt=""
          @click="changeNickNameBtnHandle()"
        />
        <img
          v-else
          slot="config_nickName_xiugai"
          src="../../../assets/img/config/duihao.png"
          alt=""
          @click="queRenNickNameBtnHandle()"
        />
      </top-nav-item>
      <!-- 右 -->
      <!-- 判断是不是界面管理状态 -->
      <top-nav-item
        v-if="$store.state.configinfo.objectMoveState"
        class="right_item "
      >
        <div @click="configJieMianReturnBtnHandle" slot="config_jie_mian">
          退出
        </div>

        <div @click="configJieMianQueRenBtnHandle" slot="config_jie_mian">
          完成
        </div>
      </top-nav-item>

      <top-nav-item v-else class="right_item">
        <img
          class="main_top_img"
          slot="topnavimg"
          src="~assets/img/topnav/caidan.png"
          @click="menuClickHandle"
          alt
        />
      </top-nav-item>

      <!-- 右上角弹出的菜单 -->
      <menu-view
        :regionMenuState="this.regionMenuState"
        v-if="this.regionMenuState.click"
        slot="topnavMenu"
        class="main_top_nav_menu"
        :class="
          this.regionMenuState.fade ? 'fade_in_public' : 'fade_out_public'
        "
      ></menu-view>
      <!-- 右上角弹出的菜单  子账号 -->
      <!-- <menu-view-son
        v-if="this.regionMenuState.click"
        slot="topnavMenu"
        class="main_top_nav_menu"
        :class="
          this.regionMenuState.fade ? 'fade_in_public' : 'fade_out_public'
        "
      ></menu-view-son> -->
    </top-nav>

    <!-- 区域页面的title -->
    <top-nav v-show="judgeActivePage() === '区域'">
      <!-- z左 -->
      <top-nav-item
        v-if="$store.state.configinfo.objectMoveState"
        class="left_item"
      ></top-nav-item>

      <top-nav-item v-else class="left_item" path="/RegionManage">
        <img
          class="main_top_img"
          slot="topnavimg"
          src="~assets/img/topnav/quyu2.png"
          alt
        />
        <div slot="topimgtext">区域选择</div>
      </top-nav-item>
      <!-- 中 -->
      <top-nav-item>
        <div slot="topimgtext">
          {{ computedRegionName }}
        </div>
      </top-nav-item>
      <!-- 右 -->
      <!-- 判断是不是界面管理状态 -->
      <top-nav-item
        v-if="$store.state.configinfo.objectMoveState"
        class="right_item "
      >
        <div @click="configJieMianReturnBtnHandle" slot="config_jie_mian">
          退出
        </div>

        <div @click="configJieMianQueRenBtnHandle" slot="config_jie_mian">
          完成
        </div>
      </top-nav-item>

      <top-nav-item v-else class="right_item">
        <img
          class="main_top_img"
          slot="topnavimg"
          src="~assets/img/topnav/caidan.png"
          @click="menuClickHandle"
          alt
        />
      </top-nav-item>
      <!-- 右上角弹出的菜单 -->
      <menu-view
        :regionMenuState="this.regionMenuState"
        v-if="this.regionMenuState.click"
        slot="topnavMenu"
        class="main_top_nav_menu"
        :class="
          this.regionMenuState.fade ? 'fade_in_public' : 'fade_out_public'
        "
      ></menu-view>
    </top-nav>

    <!-- 消息页面的title -->
    <top-nav v-show="judgeActivePage() === '消息'">
      <!--  左 -->
      <top-nav-item class="left_item"></top-nav-item>
      <!-- 中 -->
      <top-nav-item>
        <div slot="topimgtext">消息</div>
      </top-nav-item>
      <!-- 右 -->
      <!-- 判断是不是界面管理状态 -->
      <top-nav-item
        v-if="$store.state.configinfo.objectMoveState"
        class="right_item "
      >
        <div @click="configJieMianReturnBtnHandle" slot="config_jie_mian">
          退出
        </div>

        <div @click="configJieMianQueRenBtnHandle" slot="config_jie_mian">
          完成
        </div>
      </top-nav-item>

      <top-nav-item v-else class="right_item">
        <img
          class="main_top_img"
          slot="topnavimg"
          src="~assets/img/topnav/caidan.png"
          @click="menuClickHandle"
          alt
        />
      </top-nav-item>
      <!-- 右上角弹出的菜单 -->
      <menu-view
        :regionMenuState="this.regionMenuState"
        v-if="this.regionMenuState.click"
        slot="topnavMenu"
        class="main_top_nav_menu"
        :class="
          this.regionMenuState.fade ? 'fade_in_public' : 'fade_out_public'
        "
      ></menu-view>
    </top-nav>
  </div>
</template>
<script>
import {
  judgeActivePage,
  publicFadeInOut,
  jieMianStateJudge
} from 'common/tool'
import { regionPageDataRequest } from 'views/afterLogin/control/control_public_request_js'
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import menuView from 'components/content/contro-view/menu-view/menu-view' ///菜单组件
export default {
  components: {
    topNav,
    topNavItem,
    menuView
  },
  data() {
    return {
      regionMenuState: {
        click: false,
        fade: false
      },
      nickName: sessionStorage.getItem('nickName'), ///浏览器缓存读取
      nickNameChangeState: 0, ///0代表不是修改状态
      ServeData: {
        ///用来界面管理退出时还原原来的页面
        deviceList: [],
        sceneList: []
      }
      //    pageType:"control",
    }
  },
  computed: {
    computedRegionName() {
      return this.$store.state.publicinfo.regionShowPage.name
    }
  },
  methods: {
    judgeActivePage() {
      ///判断当前活跃的页面
      return judgeActivePage()
    },
    menuClickHandle() {
      ////菜单按钮的点击事件
      console.log('菜单被点击了')
      publicFadeInOut(this.regionMenuState, 400, 1) ///实现淡入淡出关闭
      // document.body.addEventListener("click", this.globalClickHandel, true); ///挂载组件的全局的点击事件
    },
    backgroundClickHandle() {
      publicFadeInOut(this.regionMenuState, 400, 1) ///实现淡入淡出关闭
    },
    globalClickHandel(event) {
      ////鼠标的全局左键点击事件
      console.log(event)
      if (event.target.className != 'main_top_img') {
        ///判断一下当前点击的元素是否是菜单按钮，避免出错
        if (this.regionMenuState.click === true) {
          ///实现点击组件之前的任意一点，关闭组件
          publicFadeInOut(this.regionMenuState, 400)
        }
        document.body.removeEventListener('click', this.globalClickHandel, true) ///移除挂载组件的全局的点击事件
      }
    },
    changeNickNameBtnHandle() {
      ////修改昵称被点击了
      console.log('x修改昵称被点击')
      this.nickNameChangeState = 1
      this.$nextTick(() => {
        //VUE的激活后聚焦的正确写法
        document.getElementById('xiugaiName').focus() ////聚焦
      })
    },
    xiugaiNameFocusHandle() {
      console.log('input聚焦了')
    },
    xiugaiNameBlurHandle() {
      console.log('input失焦了')
      // this.nickName.replace('s+', '')
      console.log(this.nickName.length)
      if (this.nickName.match(/^[ ]*$/)) {
        ////判断是否为多个空格或者为空的方法

        // this.$toast('昵称不能为空哦~')
        return
      }
      setTimeout(() => {
        ////这里需要延时1000MS时间用来避免失去焦点事件快于queRenNickNameBtnHandle事件，出现BUG
        this.nickNameChangeState = 0
        this.nickName = sessionStorage.getItem('nickName') ///浏览器缓存读取
      }, 1000)
      // this.queRenNickNameBtnHandle()
    },
    queRenNickNameBtnHandle() {
      ////确认修改被点击了
      console.log('确认修改昵称被点击')
      // this.nickName.replace('s+', '') ////判断是否为多个空格的方法
      if (this.nickName.match(/^[ ]*$/)) {
        ////判断是否为多个空格的方法
        this.$toast('修改失败，昵称不能为空哦~')
        this.nickName = sessionStorage.getItem('nickName') ///浏览器缓存读取恢复之前的值
        return
      } else if (this.nickName.length > 20) {
        this.nickName = sessionStorage.getItem('nickName') ///浏览器缓存读取恢复之前的值
        this.$toast('修改失败，昵称不能超过20个字符哦~')
        return
      }

      //////修改用户信息(基础)
      this.$request({
        method: 'post',
        url: '/user/updateUserInfo',
        data: {
          token: this.$store.state.token,
          nickName: this.nickName,
          areaNo: '',
          headImage: ''
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            console.log(res.data)
            // this.OneSceneinfo.sceneId = res.data.data.sceneId; ////拿到服务器返回的数据结果 场景id  存到仓库
            this.$showTipsToast(1, '修改成功', true) ////提示框
            this.nickNameChangeState = 0
            this.nickName = res.data.data.nickName
            sessionStorage['nickName'] = res.data.data.nickName ///用户昵称存入浏览器缓存

            // /////需要延时一下等待 input的禁用状态被更新为激活状态后 才能使用失焦事件
            // this.$nextTick(() => {
            //   //正确写法
            //   document.getElementById('xiugaiName').blur() ////失去焦点
            // })

            // this.$router.go(-1)
            // this.$router.push("ConfigSceneManage");
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    configJieMianReturnBtnHandle() {
      let ActivePage = judgeActivePage() ////当前活跃的页面
      console.log(ActivePage + '界面管理的退出按钮点击了')
      this.$store.dispatch('asyUpdataobjectMoveState', false) ///异步提交界面管理状态到仓库
      if (ActivePage === '区域') {
        this.updataRegionPage()
      } else if (ActivePage === '常用') {
        this.updataHomePage()
      }
      this.$toast('已退出界面管理~', 3000)
    },
    configJieMianQueRenBtnHandle() {
      let ActivePage = judgeActivePage() ////当前活跃的页面
      console.log(ActivePage + '界面管理的完成按钮点击了')

      let parameter = {} ///入参数据
      let tdeviceList = [] ///入参数据
      let tsceneIdList = [] ///入参数据
      let ServeData = null
      if (ActivePage === '区域') {
        ServeData = this.$store.state.publicinfo.regionServeData ///拿到仓库存储的排好序的数据
      } else if (ActivePage === '常用') {
        ServeData = this.$store.state.publicinfo.homeServeData ///拿到仓库存储的排好序的数据
      }

      console.log('仓库数据:' + this.$store.state.publicinfo.ServeData)
      // 处理设备列表入参数据
      for (let i = 0; i < ServeData.deviceList.length; i++) {
        // 数组增加对象元素
        let tdeviceListObject = {}
        console.log(ServeData.deviceList[i].remark)
        tdeviceListObject.productId = ServeData.deviceList[i].productId
        tdeviceListObject.deviceId = ServeData.deviceList[i].deviceId
        tdeviceListObject.productCode = ServeData.deviceList[i].productCode
        tdeviceList.push(tdeviceListObject)
      }
      console.log('设备处理完的数据：' + tdeviceList)
      // console.log('设备处理完的数据：' + tdeviceList[1].deviceId)

      // 处理场景列表入参数据
      for (let i = 0; i < ServeData.sceneList.length; i++) {
        console.log(ServeData.sceneList[i].sceneName)

        tsceneIdList[i] = ServeData.sceneList[i].sceneId
      }
      console.log('场景处理完的数据：' + tsceneIdList)

      if (ActivePage === '区域') {
        //当前是区域页面的管理
        parameter = {
          token: this.$store.state.token,
          deviceList: tdeviceList,
          sceneIdList: tsceneIdList,
          regionId: this.$store.state.publicinfo.regionShowPage.id,
          followState: '' ////区域传空  常用页面:1
        }
      } else if (ActivePage === '常用') {
        //当前是常用页面的管理
        parameter = {
          token: this.$store.state.token,
          deviceList: tdeviceList,
          sceneIdList: tsceneIdList,
          regionId: '', ///常用页面空
          followState: '1' ////区域传空  常用页面:1
        }
      }
      // 页面管理 接口
      console.log(parameter)
      this.$request({
        method: 'post',
        url: '/home/updateInterfaceManagement',
        data: parameter
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            console.log(res.data.data)
            this.$store.dispatch('asyUpdataobjectMoveState', false) ///异步提交界面管理状态到仓库
            this.$toast('已完成界面管理~', 3000)
            // this.serveDeviceList = res.data.data; ////拿到服务器返回的数据结果
            // this.$router.replace('home')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updataHomePage() {
      /// 获取首页常用数据接口
      this.$request({
        method: 'post',
        url: '/home/findCommonlyPage',
        data: {
          token: this.$store.state.token,
          // token: this.$store.getters.getToken,
          regionId: '',
          followState: '1' ////0未收藏的  1收藏的
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            this.ServeData = res.data.data ////拿到服务器返回的数据结果
            // this.$store.dispatch('asyUpdataServeData', res.data.data) ///异步提交当前页面需要展示的控制数据

            this.$store.dispatch('asyUpdatahomeServeData', this.ServeData) ///异步提交当前页面需要展示的控制数据,用于状态更新
            // this.$store.state.publicinfo.homeSceneCount = this.ServeData.sceneList.length
            console.log('home请求到的数据' + this.ServeData)
            this.$store.dispatch(
              'asyUpdatahomeSceneCount',
              this.ServeData.sceneList.length
            ) ///异步提交得到的数组长度
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updataRegionPage() {
      //区域的页面数据的刷新，异步请求服务器  传入要显示的区域ID 在仓库里存着
      regionPageDataRequest(
        this.$store.state.publicinfo.regionShowPage.id
      ).then(res => {
        this.ServeData = res
        // this.$store.dispatch('asyUpdataServeData', this.ServeData) ///异步提交当前页面需要展示的控制数据
        this.$store.dispatch('asyUpdataregionServeData', this.ServeData) ///异步提交当前页面需要展示的控制数据,用于状态更新
        this.$store.dispatch(
          'asyUpdataregionSceneCount',
          this.ServeData.sceneList.length
        ) ///异步提交得到的数组长度
        console.log(
          '区域页面请求得到服务器的场景总个数' + this.ServeData.sceneList.length
        )

        // 排序功能实现

        console.log(this.ServeData)
      })
    }
  },
  mounted() {
    console.log('topNAV被创建了')
  },
  activated() {
    console.log('topNAV被激活了')
  }
}
</script>

<style></style>
